module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"no category":"без категории","month_short":"м"},"en":{"month_short":"mo"}}')
  delete Component.options._Ctor
}
